import React from "react"
import Select from "react-select"
import CreatableSelect from "react-select/creatable"

import InfoPopover from "./InfoPopover"
import { Required } from "./utils"
import { getFormattedMessage } from "../../components/shared_components_registration"
import RequiredFieldWarning from "./RequiredFieldWarning"

export default function ReactSelectionElement(props) {
  const {
    list,
    name,
    label,
    boldLabel = false,
    onValueChange,
    defaultValue,
    value,
    placeholder = getFormattedMessage("general.dropdown.please.select", "-- Please Select --"),
    divStyle,
    customStyles,
    customClass,
    classNames,
    getOptionValue = (obj) => obj.value,
    getOptionLabel = (obj) => obj.value,
    required = true,
    info_desc = "",
    disabled = false,
    isMulti = true,
    isSearchable = true,
    isClearable = true,
    show_required_msg = false,
    onCreateOption,
    filterOption,
    formatOptionLabel,
    hasChanged = false,
    klass = "one-rem-margin-bottom",
  } = props
  const selectZIdxStyle = { menu: (base) => ({ ...base, zIndex: 9999, minWidth: "250px" }) }
  const Selection = !onCreateOption ? Select : CreatableSelect
  return (
    <div className={klass} {...(divStyle ? { style: divStyle } : {})}>
      {(label || info_desc) && (
        <div style={{ display: "flex" }}>
          {label && (
            <label>
              <>
                {hasChanged && (
                  <>
                    <span className="fa fa-pencil-square-o" />
                    &nbsp;
                  </>
                )}
              </>
              {boldLabel ? <b>{label}</b> : label}
              {required && <Required />}:
            </label>
          )}
          {info_desc && (
            <div>
              &nbsp;
              <InfoPopover desc={info_desc} placement={"bottom"} />
            </div>
          )}
        </div>
      )}
      <div {...(isMulti ? { className: "react-multi-select" } : {})}>
        <Selection
          name={name}
          options={list}
          getOptionLabel={getOptionLabel}
          getOptionValue={getOptionValue}
          onChange={(selected_options) => onValueChange(name, selected_options)}
          isDisabled={disabled}
          isMulti={isMulti}
          isSearchable={isSearchable}
          isClearable={isClearable}
          styles={customStyles ? { ...selectZIdxStyle, ...customStyles } : selectZIdxStyle}
          {...(onCreateOption ? { onCreateOption: onCreateOption } : {})}
          {...("defaultValue" in props ? { defaultValue: defaultValue } : {})}
          {...("value" in props ? { value: value } : {})}
          {...(placeholder ? { placeholder: placeholder } : {})}
          {...(customClass ? { className: customClass } : {})}
          {...(classNames ? { classNames: classNames } : {})}
          {...(filterOption ? { filterOption: filterOption } : {})}
          {...(formatOptionLabel ? { formatOptionLabel: formatOptionLabel } : {})}
        />
        {show_required_msg && (
          <div>
            <RequiredFieldWarning warning={show_required_msg} />
          </div>
        )}
      </div>
    </div>
  )
}
